import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DangerousHTMLSpan } from 'ecs-react-components/dist/index.es';
import { messages } from './SecureMessages.i18n';
import { messages as menuMessages } from '../Menu/Menu.i18n';
import { messages as replyMessages } from './SecureMessageReply.i18n';

const includeArchived = (filterValue) => (filterValue === 'Archived');

export const findPatientSecureMessageMembers1 = (thread) => ({
  patientMember: thread.members.find((m) => m.patientId === thread.referencedPatientId),
  providerMember: thread.members.find((m) => !m.patientId),
});

export const findPatientSecureMessageMembers = (thread) => {
  if (thread) {
    return ({
      patientMember: thread.members.find((m) => m.patientId === thread.referencedPatientId),
      providerMember: thread.members.find((m) => !m.patientId),
    });
  }
  // in some cases, we will not have a thread selected.  Return empty objects for the members.
  return ({
    patientMember: {},
    providerMember: {},
  });
};
export const formatDisplayName = (author, proxyAuthor) => {
  if (proxyAuthor && (proxyAuthor.firstName || proxyAuthor.lastName)) {
    return <FormattedMessage {...messages.arSenderText}
      values={{
        arFirstName: proxyAuthor.firstName,
        arLastName: proxyAuthor.lastName,
        patientFirstName: author.firstName,
        patientLastName: author.lastName,
      }}
    />;
  }
  return <FormattedMessage {...menuMessages.displayNameFormat}
    values={{
      0: author.firstName,
      1: author.lastName,
    }}
  />;
};

export const generateListItems = (threads, filter) => {
  if (!threads) {
    return [];
  }

  const renderHeading = (heading, date) => () => {
    const headingDate = date.timePart ? date.timePart : date.datePart;

    return (<span>
      <div className="message-date-box">
        <span className="message-date">{ headingDate }</span>
      </div>
      <span className="primary-text">{heading}</span>
            </span>);
  };

  const renderSubText = (subText, threadMessageCount) => () => (
      <span className="secondary-text bold">
        <DangerousHTMLSpan
          qaTag="subjectText"
          html={ subText }
        />&nbsp;
        { threadMessageCount > 0 ? <span className="understated">({threadMessageCount})</span> : null }
      </span>
  );

  const renderBadge = (thread) => {
    const patientMember = findPatientSecureMessageMembers(thread).patientMember;
    return !patientMember.areMessagesReviewed;
  };

  const filterAppropriateItems = threads.filter((thread) => {
    // use referenced patient id as proxy for logged-in patient id, will be true for patient portal
    const patientMember = findPatientSecureMessageMembers(thread).patientMember;
    let threadIsArchivedForPatient = false;
    if (patientMember && patientMember.isArchived) {
      threadIsArchivedForPatient = true;
    }

    return threadIsArchivedForPatient === includeArchived(filter);
  });

  const listItems = filterAppropriateItems.map((thread) => {
    const members = findPatientSecureMessageMembers(thread);
    const visibleNumberOfMessages = members.patientMember ? members.patientMember.visibleNumberOfMessages : '';
    const firstName = members.providerMember ? members.providerMember.firstName : '';
    const lastName = members.providerMember ? members.providerMember.lastName : '';
    return {
      displayBadge: renderBadge(thread),
      heading: renderHeading(
        formatDisplayName(
          {
            firstName,
            lastName,
          }
        ),
        thread.lastMessageDate),
      subText: renderSubText(
        thread.subjectText.trim(),
        visibleNumberOfMessages),
      keyaaa: thread.threadId,
      itemId: thread.threadId,
    };
  });

  return listItems;
};

export const configFilter = (filter) => ({
  value: filter || 'Current',
  id: 'secure-message-filter-input-group',
  filterConfig: [
    {
      filterTitle: <FormattedMessage { ...messages.filter.current } />,
      filterValue: 'Current',
    },
    {
      filterTitle: <FormattedMessage { ...messages.filter.archive } />,
      filterValue: 'Archived',
    },
  ],
});

export const findSelectedThread = (secureMessageState) => {
  const {
    filter,
    selectedThreadIndex,
    selectedArchivedThreadIndex,
    threads,
  } = secureMessageState;
  let selectedThread = threads.find((thd) => thd.threadId === selectedThreadIndex);

  if (filter === 'Archived') {
    selectedThread = threads.find((thd) => thd.threadId === selectedArchivedThreadIndex);
  }

  return selectedThread;
};

export const formatReplyToName = (threads, selectedThreadIndex) => {
  const thread = threads.find((t) => t.threadId === selectedThreadIndex);
  const providerMember = findPatientSecureMessageMembers(thread).providerMember;
  const firstName = providerMember ? providerMember.firstName : '';
  const lastName = providerMember ? providerMember.lastName : '';
  const displayName = <FormattedMessage {...menuMessages.displayNameFormat}
    values={{
      0: firstName,
      1: lastName,
    }}
  />;

  return (<FormattedMessage {...replyMessages.replyTo}
    values={{ name: displayName }}
  />);
};
